import React from "react";

const NumberInput = ({ question, placeholder, value, onChange }) => {
  return (
    <div className="text-input-question">
      <h4 className="question-text mb-4">{question}</h4>
      <input
        type="number"
        className="form-control"
        placeholder={placeholder}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        style={{ fontSize: "16px", padding: "12px" }}
      />
    </div>
  );
};

export default NumberInput;
